import tw from 'tailwind-styled-components'

export const Label = tw.label`
block 
font-semibold
text-xs
text-darkGray
truncate
pb-1
`
export const SwitchDiv = tw.div`
flex 
items-center 
gap-2 
mt-1.5
`
